// ** Icons Import
import { Circle, CreditCard } from 'react-feather'

export default [
    {
        id: 'survey',
        title: 'Судалгаа',
        icon: <i className="fal fa-ballot-check"></i>,
        navLink: "/survey",
        children: [
            {
                id: 'surveymain',
                title: 'Судалгаа бөглөх',
                icon: <Circle size={8} />,
                navLink: "survey/"
            }
        ]
    }
]
